// extracted by mini-css-extract-plugin
export var section = "questions-module--section--MEGN4";
export var wrapper = "questions-module--wrapper--7k7+x";
export var title = "questions-module--title--0UsxS";
export var listWrapper = "questions-module--list-wrapper--0Di9Y";
export var moreQuestionLink = "questions-module--more-question-link--3eB6T";